import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Image from "next/image";

import ContainerButton from "@kikoff/components/src/v1/buttons/ContainerButton";
import { web } from "@kikoff/proto/src/protos";

import arrowLeft from "@asset/icons/arrow_left.svg";
import PageAlign from "@component/dashboard/offer/page_align";
import ViewTemplate from "@component/dashboard/offer/view_template";
import { PageRegistration } from "@component/flows/hooks/usePageFlow";
import { updateBag } from "@feature/shopping";
import { getKikoffCreditServiceGenericBothMentalModelName } from "@src/constants";

import { ProductList } from "./select_product";

import styles from "./old_store.module.scss";

interface OldStoreProps extends PageRegistration {}

export default function OldStore({ page }: OldStoreProps) {
  const dispatch = useDispatch();

  const preview = useSelector((state) => state.shopping.checkoutPreview);
  const products = useSelector((state) => state.shopping.products);
  const kikoffCreditServiceProducts = products.filter(
    ({ type }) => type === web.public_.Product.Type.SUBSCRIPTION
  );

  const [kikoffCreditServices, setKikoffCreditServices] = useState(true);

  return (
    <PageAlign scroll overscroll={false}>
      <div className={styles["old-store-header"]}>
        <ContainerButton
          onClick={() => {
            page.controller.history.back();
          }}
        >
          <Image src={arrowLeft} alt="back" />
        </ContainerButton>
        <div className={styles.title} data-cy="app-bar-title">
          Select an item
        </div>
      </div>
      <ViewTemplate
        note={
          <div className={styles["subtitle"]}>
            You can pick between{" "}
            {getKikoffCreditServiceGenericBothMentalModelName()} or an e-book,
            if you’re into reading. All items will help you build your credit by
            building payment history.
          </div>
        }
      >
        <ProductList
          products={
            kikoffCreditServices ? kikoffCreditServiceProducts : products
          }
          onContinue={(product) => {
            addProductToBag(dispatch, preview, product);
            page.controller.next();
          }}
        />
        {kikoffCreditServices && preview && (
          <div className={styles["load-more-items-wrapper"]}>
            <a
              className={styles["select-another-item"]}
              onClick={() => {
                setKikoffCreditServices(false);
              }}
            >
              Load more items
            </a>
          </div>
        )}
      </ViewTemplate>
    </PageAlign>
  );
}

export function addProductToBag(dispatch, preview, product) {
  dispatch(
    updateBag({
      items: [{ product, quantity: 1 }],
      autoRenew: {
        status: preview.autoRenew?.status,
      },
    })
  );
}
